<!-- eslint-disable vue/no-v-html -->
<template>
    <div
        v-if="editMode == 'edit'"
        :class="['v-text', fontFamilyCls]"
        @keydown="handleKeydown"
        @keyup="handleKeyup"
    >
        <span class="v-text-actual" ref="actualText">{{element.propValue}}</span>
        <!-- tabindex >= 0 使得双击时聚集该元素 -->
        <div
            ref="text"
            :contenteditable="canEdit"
            :class="{ canEdit }"
            :tabindex="element.id"
            :style="{ verticalAlign: element.style.verticalAlign }"
            @dblclick="setEdit"
            @paste="clearStyle"
            @mousedown="handleMousedown"
            @blur="handleBlur"
            @input="handleInput"
            v-html="element.propValue"
        ></div>
    </div>
    <div v-else :class="['v-text', 'preview', fontFamilyCls]">
        <div :style="{ verticalAlign: element.style.verticalAlign }" v-html="element.propValue"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { keycodes } from '@/utils/shortcutKey.js'
import { fontFamilyMap } from '@/utils/attrNameData';

export default {
    props: {
        propValue: {
            type: String,
            require: true,
            default: '',
        },
        element: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            canEdit: false,
            ctrlKey: 17,
            isCtrlDown: false,
            resizeObserver: null,
        }
    },
    computed: {
        ...mapState([
            'editMode',
        ]),
        fontFamilyCls() {
            let cls = '';
            if (this.element.style && this.element.style.fontFamily) {
                cls = 'diy-' + fontFamilyMap[this.element.style.fontFamily];
            }
            return cls;
        }
    },
    watch: {
        editMode() {
            this.$nextTick(() => this.bindTextResizeObserver());
        },
    },
    mounted() {
        this.bindTextResizeObserver();
    },
    beforeDestroy() {
        this.unbindTextResizeObserver();
    },
    methods: {
        bindTextResizeObserver() {
            this.unbindTextResizeObserver();
            if (this.editMode !== "edit") {
                return;
            }
            const el = this.$refs.actualText;
            if (!el || typeof el !== "object" || el.nodeType !== 1) {
                return;
            }
            if (typeof ResizeObserver === "undefined") {
                return;
            }
            this.resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    var actualWidth = entry.contentRect.width;
                    var actualHeight = entry.contentRect.height;
                    if (!this.element || !this.element.style) {
                        continue;
                    }
                    if (this.element.style.width < actualWidth || this.element.style.width > actualWidth) {
                        this.element.style.width = actualWidth;
                    }
                    if (this.element.style.height < actualHeight || this.element.style.height > actualHeight) {
                        this.element.style.height = actualHeight;
                    }
                }
            });
            this.resizeObserver.observe(el);
        },
        unbindTextResizeObserver() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        },
        handleInput(e) {
            this.$emit('input', this.element, e.target.innerHTML)
        },

        handleKeydown(e) {
            if (e.keyCode == this.ctrlKey) {
                this.isCtrlDown = true
            } else if (this.isCtrlDown && this.canEdit && keycodes.includes(e.keyCode)) {
                e.stopPropagation()
            } else if (e.keyCode == 46) { // deleteKey
                e.stopPropagation()
            }
        },

        handleKeyup(e) {
            if (e.keyCode == this.ctrlKey) {
                this.isCtrlDown = false
            }
        },

        handleMousedown(e) {
            if (this.canEdit) {
                e.stopPropagation()
            }
        },

        clearStyle(e) {
            e.preventDefault()
            const clp = e.clipboardData
            const text = clp.getData('text/plain') || ''
            if (text !== '') {
                document.execCommand('insertText', false, text)
            }

            this.$emit('input', this.element, e.target.innerHTML)
        },

        handleBlur(e) {
            this.element.propValue = e.target.innerHTML || '&nbsp;'
            const html = e.target.innerHTML
            if (html !== '') {
                this.element.propValue = e.target.innerHTML
            } else {
                this.element.propValue = ''
                this.$nextTick(() => {
                    this.element.propValue = '&nbsp;'
                })
            }
            this.canEdit = false
        },

        setEdit() {
            if (this.element.isLock) return

            this.canEdit = true
            // 全选
            this.selectText(this.$refs.text)
        },

        selectText(element) {
            const selection = window.getSelection()
            const range = document.createRange()
            range.selectNodeContents(element)
            selection.removeAllRanges()
            selection.addRange(range)
        },
    },
}
</script>

<style lang="scss" scoped>
.v-text {
    width: 100%;
    height: 100%;
    display: table;
    .v-text-actual {
        position: absolute;
        z-index: -1;
        width: auto;
        white-space: pre;
        visibility: hidden;
    }
    div {
        display: table-cell;
        width: 100%;
        height: 100%;
        outline: none;
        white-space: pre;
    }

    .canEdit {
        cursor: text;
        height: 100%;
    }
}

.preview {
    user-select: none;
}
</style>
